<lib-curved-box
  [curve]="brand.isYallo() ? 'top' : 'none'"
  [horizontalLines]="brand.isChmobile() ? 'both' : 'none'"
  [lightTheme]="lightTheme()"
  [showOverflow]="brand.isChmobile()"
>
  <div class="container">
    <div class="py-10 mx-5 flex flex-col lg:flex-row justify-between">
      @for (link of slice.linkItems; track link; let i = $index) {
        <div class="w-full lg:max-w-xs">
          <lib-link [link]="link.url">
            <div
              class="flex justify-between items-center footer-cta-item"
              [ngClass]="{ 'text-white': !lightTheme(), 'text-[--color-text-primary]': lightTheme() }"
            >
              <div
                class="flex items-center justify-center p-3 border border-[--color-border-footer-cta-item] lg:border-2 border-opacity-40 rounded-full mr-3"
              >
                @if (link.icon) {
                  <lib-svg
                    class="medium"
                    [ngClass]="{ white: !lightTheme(), '[&_path]:fill-[--color-text-primary]': lightTheme() }"
                    [svg]="link.icon"
                  />
                }
              </div>
              <div class="grow flex flex-col">
                <div data-source="prismic" [innerHtml]="link.title">{{ link.title }}</div>
                <div data-source="prismic" class="hidden lg:block" [innerHtml]="link.description"></div>
              </div>
              <lib-svg
                [ngClass]="{ white: !lightTheme(), '[&_path]:fill-[--color-text-primary]': lightTheme() }"
                class="lg:hidden normal"
                svg="fontawesome/arrow-right"
              />
            </div>
          </lib-link>
          @if (i !== slice.linkItems.length - 1) {
            <hr class="my-2 bg-white opacity-40 lg:hidden" />
          }
        </div>
      }
    </div>
  </div>
  @if (brand.isChmobile()) {
    <lib-svg
      svg="half-cross"
      class="absolute right-0 -bottom-[100px] select-none [&_svg]:w-[92px] [&_svg]:h-auto [&_svg]:fill-white"
    />
  }
</lib-curved-box>
